


















import { Component, Vue, Prop } from "vue-property-decorator";
import {
  COLOR_BUTTON_LINK_ACTION,
  COLOR_BUTTON_GREEN,
  COLOR_BUTTON_YELLOW,
  COLOR_BUTTON_LINK,
  COLOR_BUTTON_RED,
  COLOR_PROJECT_STEP_BUTTON_COMPLETE,
  COLOR_PROJECT_STEP_BUTTON_OVERDUE,
  COLOR_PROJECT_STEP_BUTTON_INCOMPLETE,
  COLOR_PROJECT_STEP_BUTTON_REPORT,
  COLOR_BUTTON_DISABLED,
  COLOR_SURFACE_ELEVATED_DARK,
} from "./../../utils/colors";
import { themed, themedFill, themedFillTextClass } from "@/utils/Theme";

export enum ButtonState {
  RED,
  GREEN,
  YELLOW,
  GRAY_NOT_DISABLED,

  DISABLED,
  LINK,
  LINK_ACTION,

  STEP_BUTTON_COMPLETED,
  STEP_BUTTON_INCOMPLETE,
  STEP_BUTTON_OVERDUE,
  STEP_BUTTON_REPORT,
}

export function getButtonStateColor(buttonState: ButtonState) {
  switch (buttonState) {
    case ButtonState.GREEN:
      return COLOR_BUTTON_GREEN;
    case ButtonState.YELLOW:
      return COLOR_BUTTON_YELLOW;

    case ButtonState.LINK:
      return COLOR_BUTTON_LINK;
    case ButtonState.LINK_ACTION:
      return COLOR_BUTTON_LINK_ACTION;

    case ButtonState.STEP_BUTTON_COMPLETED:
        return COLOR_PROJECT_STEP_BUTTON_COMPLETE;
    case ButtonState.STEP_BUTTON_INCOMPLETE:
      return COLOR_PROJECT_STEP_BUTTON_INCOMPLETE;
    case ButtonState.STEP_BUTTON_OVERDUE:
      return COLOR_PROJECT_STEP_BUTTON_OVERDUE;
    case ButtonState.STEP_BUTTON_REPORT:
      return COLOR_PROJECT_STEP_BUTTON_REPORT;
    
    case ButtonState.GRAY_NOT_DISABLED:
    case ButtonState.DISABLED:
      return COLOR_BUTTON_DISABLED;

    default:
      return COLOR_BUTTON_RED;
  }
}

export function getButtonStateClass(buttonState: ButtonState) {
  let buttonClass = "";

  switch (buttonState) {
    case ButtonState.RED:
    case ButtonState.GREEN:
    case ButtonState.YELLOW:
      buttonClass += "white--text";
      break;
    case ButtonState.GRAY_NOT_DISABLED:
      buttonClass += "gray-not-disabled";
      break;
    default:
      buttonClass += "black--text";
      break;
  }

  return buttonClass;
}

@Component
export default class StateButtonComponent extends Vue {
  @Prop({ default: ButtonState.RED }) state!: ButtonState;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) removeRoundedCorners!: boolean;

  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) block!: boolean;
  @Prop({ default: false }) verySmall!: boolean;

  get removeBorderRadius() {
    return this.state == ButtonState.LINK || this.state == ButtonState.LINK_ACTION;
  }

  get disabled() {
    return this.state == ButtonState.DISABLED;
  }

  get elevation() {
    switch (this.state) {
      case ButtonState.LINK:
      case ButtonState.LINK_ACTION:
        return 0;
      default:
        return 2;
    }
  }

  /**
   * The fill for the active theme. Dark mode takes the one palette shade of each colour
   * (`themedFill`); GRAY_NOT_DISABLED instead mirrors Vuetify's dark disabled look, because that
   * state exists to look disabled while staying clickable.
   */
  get stateColor() {
    const lightColor = getButtonStateColor(this.state);

    return this.state === ButtonState.GRAY_NOT_DISABLED
      ? themed(lightColor, COLOR_SURFACE_ELEVATED_DARK)
      : themedFill(lightColor);
  }

  get buttonClass() {
    const lightClass = getButtonStateClass(this.state);
    let buttonClass = this.state === ButtonState.GRAY_NOT_DISABLED
      ? lightClass
      : themedFillTextClass(getButtonStateColor(this.state), lightClass);

    if (this.removeRoundedCorners) {
      buttonClass += " no-rounded-corners";
    }

    return buttonClass;
  }

  onClicked() {
    this.$emit("click");
  }
}
